import imageUrlBuilder from '@sanity/image-url'
import { getImageDimensions } from '@sanity/asset-utils'

// TODO move to config?
const builder = imageUrlBuilder({ projectId: 'whc4dqyy', dataset: 'production' })

export function imageBuilder(image: { _id?: string | null; originalFilename?: string | null }) {
  // @ts-expect-error types don't allow null but it works
  return builder.image(image).vanityName(encodeURIComponent(image.originalFilename))
}

export function getLowSrc(
  image: { _id: string | null | undefined },
  size?: { width?: number; height?: number },
) {
  if (!image._id) {
    return null
  }
  const { width } = getImageDimensions(image._id)
  if (width <= 600 || (size?.width && size.width <= 600)) {
    return null
  }
  return imageBuilder(image).auto('format').fit('max').width(600).blur(300).toString()
}

export function getSrcset(
  image: { _id?: string | null },
  size?: { width?: number; height?: number },
) {
  if (!image._id) {
    return null
  }
  const { width } = getImageDimensions(image._id)
  if (size?.width || size?.height) {
    const img = imageBuilder(image)
      .auto('format')
      .fit(size.width && size.height ? 'crop' : 'max')
    const customWidth = size.width ? img.width(size.width) : img
    const customImg = size.height ? customWidth.height(size.height) : img
    return [`${customImg.toString()} 1x`, `${customImg.dpr(2).toString()} 2x`]
  }
  const img = imageBuilder(image).auto('format').fit('max')
  if (width <= 800) {
    return [`${img.toString()} 1x`]
  }
  const widths = [800, 1200, 1800, 2400].filter((val) => val < width)
  return widths.map((w) => `${img.width(w).toString()} ${w}w`)
}
